module.exports = __webpack_public_path__ + "static/media/comm0.1780e4a8.jpg";